<div class="quote-rate-limiter" (click)="this.showPopup()">
  <div class="number">{{this.quoteRateDisplayValue}}</div>
  <div class="text">{{this.currentMode}}</div>
</div>

<dx-popup [width]="330"
          [height]="380"
          title="Quote Throttling Settings"
          [showTitle]="true"
          [closeOnOutsideClick]="false"
          [resizeEnabled]="true"
          [dragEnabled]="true"
          [visible]="this.isPopupVisible"
          (onHidden)="this.onPopupClosed()">
  <div *dxTemplate="let data of 'content'" #content>
    
    <div class="settings">
      <div class="headers">
        <div class="row">
          <div class="label">&nbsp;</div>
          <div class="rate">Rate</div>
          <div class="threshold">Threshold</div>
        </div>
      </div>
      
      <div class="row">
        <div class="label">Mode 3</div>
        <div class="rate">
          <dx-number-box [(value)]="this.tempSettings.mode3Rate" [inputAttr]="{style: 'text-align: center;'}"></dx-number-box>
        </div>
        <div class="threshold">
          <dx-text-box [readOnly]="true" text="Ultimate Threshold"  [disabled]="true" [inputAttr]="{style: 'text-align: center;'}">
          </dx-text-box>
        </div>
      </div>
      
      <div class="row">
        <div class="label">Mode 2</div>
        <div class="rate">
          <dx-number-box [(value)]="this.tempSettings.mode2Rate" [inputAttr]="{style: 'text-align: center;'}"></dx-number-box>
        </div>
        <div class="threshold">
          <dx-number-box [(value)]="this.tempSettings.mode2Threshold" [inputAttr]="{style: 'text-align: center;'}"></dx-number-box>
        </div>
      </div>
      
      <div class="row">
        <div class="label">Mode 1</div>
        <div class="rate">
          <dx-text-box [readOnly]="true" [disabled]="true" text="UF" [inputAttr]="{style: 'text-align: center;'}">
          </dx-text-box>
        </div>
        <div class="threshold">
          <dx-number-box [(value)]="this.tempSettings.mode1Threshold" [inputAttr]="{style: 'text-align: center;'}"></dx-number-box>
        </div>
      </div>
      
      <hr style="width: 40%">
      
      <div class="current-mode">
        <div class="label">Mode</div>
        <div class="input">
          
          <ng-container *ngIf="!this.tempSettings.isManualModeSwitch">
            <dx-text-box [readOnly]="true"  [value]="this.tempSettings.currentMode" [inputAttr]="{style: 'text-align: center;'}"
            ></dx-text-box>
          </ng-container>
          
          <ng-container *ngIf="this.tempSettings.isManualModeSwitch">
            <dx-select-box [items]="this.modeList"
                           [(value)]="this.tempSettings.manualMode"
                           (onValueChanged)="this.onCurrentModeManualChange($event)"
                           [inputAttr]="{style: 'text-align: center;'}">
            </dx-select-box>
          </ng-container>
          
        </div>
      </div>
      
      <div class="manual-mode-switch">
        <dx-check-box text="Enable Manual Mode Switch"
                      [(value)]="this.tempSettings.isManualModeSwitch"
          (onValueChanged)="this.onManualModeSwitchChanged($event)">
        </dx-check-box>
      </div>
      
      <div class="quote-rate-type">
        <div class="label">Display Quote Rate</div>
        <div class="input">
          <dx-select-box [items]="this.visibleRateKindList"
                         [(value)]="this.tempSettings.visibleRateKind"
                         [inputAttr]="{style: 'text-align: center;'}"
          >
          </dx-select-box>
        </div>
      </div>
      
    </div>
    
    <div class="buttons">
      <div class="btn save">
        <dx-button text="Save" width="100%" (onClick)="this.saveThrottlingSettings()"></dx-button>
      </div>
      <div class="btn cancel">
        <dx-button text="Cancel" width="100%" (onClick)="this.closePopup()"></dx-button>
      </div>
    </div>
    
    <dx-load-panel [visible]="this.isPopupDataLoading" [position]="{my: 'center', at: 'center', of: content}">
    </dx-load-panel>
  </div>
</dx-popup>